module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-dune-fluted-hayman-1.2fa79630.jpg";